import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cv-point-store-cxone-sidebar',
  templateUrl: './point-store-cxone-sidebar.component.html',
  styleUrls: ['./point-store-cxone-sidebar.component.scss']
})
export class PointStoreCxoneSidebarComponent implements OnInit {

  collapseSideBar:boolean = true;

  constructor() { }

  ngOnInit(): void {
  }

}
